
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile/contract/quit",
      function () {
        return require("private-next-pages/mobile/contract/quit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile/contract/quit"])
      });
    }
  